import theme from '@gaia/theme';
import {getMapControlsWidth} from '@map/controls/ControlsDrawer';
import {useMediaQuery} from '@mui/material';

export interface MapPadding {
    left: number;
    right: number;
    top: number;
    bottom: number;
}

export default function useGetPaddingForSelectionEffect(
    sidebarWidth: number,
    controlsExpanded: boolean
) {
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const paddingValue = isSmallScreen ? 50 : 150;
    const controlWidth = getMapControlsWidth(controlsExpanded);
    return {
        left: sidebarWidth + controlWidth + paddingValue,
        right: paddingValue,
        top: paddingValue,
        bottom: paddingValue,
    };
}
